// extracted by mini-css-extract-plugin
export default {"recos":"B--z","productCardOverride":"C--z","rowHasBadge":"D--z"};